import { Box, Stack, StackProps } from "@mui/material";
import { ReactNode, RefObject } from "react";
import { ElementToPrint } from "./element";
import { PrintContent } from "./print-content";
import { RowsElementProps } from "./rows-element";
import { TemplateLayer } from "./template-layer";

export type PaperSize = {
  width: string;
  height: string;
};

export type PrintPageProps = {
  className?: string;
  strictPaperBox?: boolean;
  fontSize?: string;
  paperSize: PaperSize;
  paperPadding?: string;
  templateImage?: string;
  elements?: ElementToPrint[] | ReactNode;
  rowsElement?: RowsElementProps;
  backgroundSize?: string;
  backgroundPosition?: string;
  containerRef?: RefObject<HTMLDivElement>;
  contentRef?: RefObject<HTMLDivElement>;
  showBorder?: boolean;
};

export const PrintPage = ({
  className,
  strictPaperBox = false,
  fontSize,
  paperSize,
  paperPadding,
  templateImage,
  elements = [],
  rowsElement,
  backgroundSize,
  backgroundPosition,
  containerRef,
  contentRef,
  showBorder = true,
}: PrintPageProps) => {
  return (
    <Box
      className={className}
      width={paperSize.width}
      height={paperSize.height}
      sx={{
        boxSizing: strictPaperBox ? "border-box" : undefined,
        overflow: strictPaperBox ? "hidden" : undefined,
        padding: paperPadding || undefined,
        border: showBorder ? "1px solid " : undefined,
      }}
      ref={containerRef}
    >
      <PrintAreaContainer
        width={"100%"}
        height={"100%"}
        maxHeight={"100%"}
        maxWidth={"100%"}
        sx={{
          position: "relative",
        }}
      >
        <PrintContent
          fontSizeDefault={fontSize}
          innerRef={contentRef || null}
          elements={elements}
          rowsElement={rowsElement}
        ></PrintContent>

        {templateImage && (
          <TemplateLayer
            backgroundSize={backgroundSize}
            templateImage={templateImage}
            backgroundPosition={backgroundPosition}
          ></TemplateLayer>
        )}
      </PrintAreaContainer>
    </Box>
  );
};

type PrintAreaContainerProps = StackProps & {
  innerRef?: RefObject<HTMLDivElement> | null;
};

const PrintAreaContainer = ({
  innerRef,
  ...props
}: PrintAreaContainerProps) => {
  return (
    <Stack
      ref={innerRef}
      {...props}
      sx={{
        ...props.sx,
        width: props.width,
        height: props.height,
        position: "relative",
      }}
    ></Stack>
  );
};
